// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dkt0XuBisfuw2SHNhlJM{max-width:240px;box-shadow:inset 0 0 0 1px var(--light-blue-30,#bcdaf1);background:var(--light-blue-20);color:var(--light-blue-100);outline:3px solid var(--border-neutral-default);border-radius:8px;padding:8px 12px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"branchLabel": `Dkt0XuBisfuw2SHNhlJM`
};
export default ___CSS_LOADER_EXPORT___;
